<template>
    <div class="top-banner" role="status" aria-live="polite">
        <div class="top-banner__viewport">
            <div class="top-banner__track" :style="{ animationDuration: duration + 's' }">
                <div class="top-banner__item">
                    <span class="top-banner__text">
                        {{ text }}
                        <template v-if="linkUrl">
                            <a
                                :href="linkUrl"
                                class="top-banner__link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >{{ linkLabel }}</a>.
                        </template>
                    </span>
                </div>
                <div class="top-banner__item" aria-hidden="true">
                    <span class="top-banner__text">
                        {{ text }}
                        <template v-if="linkUrl">
                            <a
                                :href="linkUrl"
                                class="top-banner__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                tabindex="-1"
                            >{{ linkLabel }}</a>.
                        </template>
                    </span>
                </div>
                <div class="top-banner__item" aria-hidden="true">
                    <span class="top-banner__text">
                        {{ text }}
                        <template v-if="linkUrl">
                            <a
                                :href="linkUrl"
                                class="top-banner__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                tabindex="-1"
                            >{{ linkLabel }}</a>.
                        </template>
                    </span>
                </div>
                <div class="top-banner__item" aria-hidden="true">
                    <span class="top-banner__text">
                        {{ text }}
                        <template v-if="linkUrl">
                            <a
                                :href="linkUrl"
                                class="top-banner__link"
                                target="_blank"
                                rel="noopener noreferrer"
                                tabindex="-1"
                            >{{ linkLabel }}</a>.
                        </template>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopBanner',
    props: {
        text: {
            type: String,
            required: true
        },
        linkUrl: {
            type: String,
            default: ''
        },
        linkLabel: {
            type: String,
            default: ''
        },
        duration: {
            type: Number,
            default: 50
        }
    }
};
</script>

<style scoped>
.top-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: var(--top-banner-height, 30px);
    z-index: 1000;
    background: #ec2b00;
    color: #fff;
    display: flex;
    align-items: center;
    padding-top: 2px;
}

.top-banner__viewport {
    width: 100%;
    overflow: hidden;
}

.top-banner__track {
    display: flex;
    width: max-content;
    animation-name: top-banner-marquee;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    will-change: transform;
}

.top-banner__item {
    display: flex;
    align-items: center;
    padding-right: 30px;
}

.top-banner__text {
    white-space: nowrap;
    font-size: 1.5rem;
    line-height: 1;
    padding: 0 16px;
}

.top-banner__link {
    color: #fff;
    text-decoration: underline;
    font-weight: 600;
}

.top-banner__link:hover,
.top-banner__link:focus {
    text-decoration: none;
}

@keyframes top-banner-marquee {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-50%);
    }
}

@media (prefers-reduced-motion: reduce) {
    .top-banner__track {
        animation: none;
        transform: none;
    }
    .top-banner__item[aria-hidden='true'] {
        display: none;
    }
}
</style>
